import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import * as Styled from './MoneyField.styles';
import NumberFormat from 'react-number-format';
export default function MoneyField({
  title,
  disabled,
  value,
  width,
  height,
  margin,
  required,
  name,
  control,
  valueType,
}) {
  const max_money = 999999999;
  const max_percent = 9999;
  const max_day = 999;
  const withValueLimit = ({ floatValue }) => floatValue <= max_money;
  const withPercentLimit = ({ floatValue }) => floatValue <= max_percent;
  const withDayLimit = ({ floatValue }) => floatValue <= max_day;

  const isRequired = required !== undefined ? required : true;

  function currencyFormatter(value) {
    if (!Number(value)) return 'R$ 0,00';
    const amount = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(value / 100);

    return `${amount}`;
  }

  function percentFormatter(value) {
    if (!Number(value)) return '0,00 %';
    const amount = new Intl.NumberFormat('pt-BR', {
      style: 'percent',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(value / 10000);

    return `${amount}`;
  }

  function integerFormatter(value) {
    if (!Number(value)) return '0';
    const amount = new Intl.NumberFormat('pt-BR', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(value);

    return `${amount}`;
  }

  function renderSwitch(valueType) {
    switch (valueType) {
      case '1':
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={value}
            render={({ field }) => (
              <NumberFormat
                {...field}
                allowEmptyFormatting={true}
                thousandSeparator={'.'}
                decimalSeparator={','}
                fixedDecimalScale={true}
                customInput={Styled.Input}
                width={width}
                height={height}
                disabled={disabled}
                isAllowed={withValueLimit}
                format={currencyFormatter}
              />
            )}
          ></Controller>
        );
      case '2':
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={value}
            render={({ field }) => (
              <NumberFormat
                {...field}
                allowEmptyFormatting={true}
                thousandSeparator={'.'}
                decimalSeparator={','}
                fixedDecimalScale={true}
                customInput={Styled.Input}
                width={width}
                height={height}
                disabled={disabled}
                isAllowed={withPercentLimit}
                format={percentFormatter}
              />
            )}
          ></Controller>
        );
      default:
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={parseInt(value)}
            render={({ field }) => (
              <NumberFormat
                {...field}
                allowEmptyFormatting={true}
                customInput={Styled.Input}
                width={width}
                height={height}
                disabled={disabled}
                isAllowed={withDayLimit}
                format={integerFormatter}
              />
            )}
          ></Controller>
        );
    }
  }

  return (
    <Styled.Container width={width} height={height} margin={margin}>
      <Styled.Title>{title}</Styled.Title>
      {renderSwitch(valueType)}
    </Styled.Container>
  );
}

MoneyField.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  control: PropTypes.any,
  field: PropTypes.any,
  valueType: PropTypes.string,
};
